import { UserSelfEmployed } from '../../../shared/models/user-self-employed.model';
import { User } from '../../../shared/models/user.model';
import { StudentsForImpactService } from '../../../shared/services/students-for-impact.service';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-citizens-for-impact-validate',
  templateUrl: './citizens-for-impact-validate.component.html',
  styleUrls: ['./citizens-for-impact-validate.component.css']
})
export class CitizensForImpactValidateComponent implements OnInit {

  @Input() user: User;
  @ViewChild('tab1', { static: false }) tab1: ElementRef;
  @ViewChild('tab2', { static: false }) tab2: ElementRef;

  modalTitle = 'Validation des documents Citizens for Impact';
  idCardForm: FormGroup;
  selfEmployedForm: FormGroup;

  showButtonNext = true;
  showButtonPrevious = false;
  showButtonSave = false;

  tab1Validated = false;
  tab2Validated = false;

  idCardValidated: boolean = null;
  selfEmployedValidated: boolean = null;

  private idCardValidationData: {
    status: number;
    status_message: string;
  } = null;

  private selfEmployedValidationData: {
    status: number;
    status_message: string;
  } = null;

  private tabCurrent = 0;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private service: StudentsForImpactService
  ) { }

  ngOnInit() {
    this.initForms();
    this.loadUserData();
  }

  initForms() {
    this.idCardForm = this.formBuilder.group({
      status_message: ['']
    });

    this.selfEmployedForm = this.formBuilder.group({
      status_message: ['']
    });
  }

  loadUserData() {
    if (this.user && this.user.self_employed) {
      this.selfEmployedForm.patchValue({
        status_message: this.user.self_employed.status_message || ''
      });
    }
  }

  getFormattedBirthDate(): string {
    if (!this.user || !this.user.birth_date) { return ''; }
    const date = new Date(this.user.birth_date);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    return `${day}/${month}/${date.getFullYear()}`;
  }

  getFullAddress(): string {
    if (!this.user || !this.user.user_adresses) { return ''; }
    const addr = this.user.user_adresses;
    return `${addr.address_line_1 || ''}, ${addr.post_code || ''} ${addr.city || ''}, ${addr.state || ''}`;
  }

  isPdf(url: string): boolean {
    return url && url.toLowerCase().includes('.pdf');
  }

  onValidateIdCard() {
    this.idCardValidated = true;
    this.tab1Validated = true;
    this.idCardValidationData = { status: 2, status_message: '' };
  }

  onRejectIdCard() {
    const statusReason = this.idCardForm.get('status_message').value;
    if (!statusReason || statusReason.trim() === '') {
      alert('La raison du rejet est obligatoire pour rejeter la pièce d\'identité.');
      return;
    }
    this.idCardValidated = false;
    this.tab1Validated = true;
    this.idCardValidationData = { status: 3, status_message: statusReason };
  }

  onValidateSelfEmployed() {
    this.selfEmployedValidated = true;
    this.tab2Validated = true;
    this.selfEmployedValidationData = { status: 2, status_message: '' };
  }

  onRejectSelfEmployed() {
    const statusReason = this.selfEmployedForm.get('status_message').value;
    if (!statusReason || statusReason.trim() === '') {
      alert('La raison du rejet est obligatoire pour rejeter le statut auto-entrepreneur.');
      return;
    }
    this.selfEmployedValidated = false;
    this.tab2Validated = true;
    this.selfEmployedValidationData = { status: 3, status_message: statusReason };
  }

  onNext() {
    if (!this.tab1Validated) {
      alert('Vous devez valider ou rejeter la pièce d\'identité avant de continuer.');
      return;
    }
    this.tabCurrent++;
    this.onNavigate();
  }

  onBack() {
    this.tabCurrent--;
    this.onNavigate();
  }

  onSave() {
    if (!this.tab2Validated) {
      alert('Vous devez valider ou rejeter le statut auto-entrepreneur avant d\'enregistrer.');
      return;
    }

    const validationData = {
      userId: this.user.id,
      id_card: {
        status: this.idCardValidationData.status,
        status_message: this.idCardValidationData.status_message || null
      },
      self_employed: {
        status: this.selfEmployedValidationData.status,
        status_message: this.selfEmployedValidationData.status_message || null
      }
    };

    this.service.validateImpactDocuments(this.user.id, validationData).subscribe(
      () => {
        if (!this.user.self_employed) {
          this.user.self_employed = new UserSelfEmployed();
        }
        this.user.self_employed.id_card_status = this.idCardValidationData.status;
        this.user.self_employed.status = this.selfEmployedValidationData.status;
        this.user.self_employed.status_message = this.selfEmployedValidationData.status_message;

        this.activeModal.close('validation-success');
      },
      error => {
        console.error('Error validating documents:', error);
        alert('Erreur lors de l\'enregistrement de la validation.');
      }
    );
  }

  onCancel() {
    if (this.tab1Validated || this.tab2Validated ||
      this.idCardForm.dirty || this.selfEmployedForm.dirty) {
      if (confirm('Attention : toutes les données saisies seront perdues. Êtes-vous sûr de vouloir annuler ?')) {
        this.activeModal.dismiss('cancel');
      }
    } else {
      this.activeModal.dismiss('cancel');
    }
  }

  onNavigate() {
    switch (this.tabCurrent) {
      case 0:
        this.modalTitle = 'Validation de la pièce d\'identité';
        this.showButtonPrevious = false;
        this.showButtonNext = true;
        this.showButtonSave = false;
        this.selectTab(this.tab1);
        break;
      case 1:
        this.modalTitle = 'Validation du statut Auto-entrepreneur';
        this.showButtonPrevious = true;
        this.showButtonNext = false;
        this.showButtonSave = true;
        this.selectTab(this.tab2);
        break;
      default:
        this.modalTitle = 'Validation de la pièce d\'identité';
        this.showButtonPrevious = false;
        this.showButtonNext = true;
        this.showButtonSave = false;
        this.selectTab(this.tab1);
        break;
    }
  }

  selectTab(tab: ElementRef): void {
    [this.tab1, this.tab2].forEach(t => {
      if (t) { t.nativeElement.classList.remove('active'); }
    });
    if (tab) { tab.nativeElement.classList.add('active'); }
  }
}
